import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { mayLoadAnalytics } from './utils/cookieConsent';
import { getApiUrl } from './utils/apiConfig';
import { installClientBuildInterceptors } from './utils/clientBuild';

installClientBuildInterceptors(getApiUrl);

// Suppress browser extension errors in production
// These are harmless but create console noise
if (process.env.NODE_ENV === 'production') {
  const originalError = console.error;
  console.error = (...args: any[]) => {
    // Filter out browser extension errors
    const errorMessage = args[0]?.toString() || '';
    const isExtensionError = 
      errorMessage.includes('background-redux-new.js') ||
      errorMessage.includes('chrome-extension://') ||
      errorMessage.includes('Invalid frameId') ||
      errorMessage.includes('No tab with id') ||
      errorMessage.includes('runtime.lastError') ||
      errorMessage.includes('lastpass.com') ||
      errorMessage.includes('ERR_INTERNET_DISCONNECTED') ||
      errorMessage.includes('ERR_NAME_NOT_RESOLVED');
    
    if (!isExtensionError) {
      originalError.apply(console, args);
    }
  };

  // Also filter WebSocket errors from extensions
  const originalWarn = console.warn;
  console.warn = (...args: any[]) => {
    const warnMessage = args[0]?.toString() || '';
    const isExtensionWarning = 
      warnMessage.includes('background-redux-new.js') ||
      warnMessage.includes('chrome-extension://') ||
      warnMessage.includes('lastpass.com') ||
      warnMessage.includes('Cross-Origin-Opener-Policy');
    
    if (!isExtensionWarning) {
      originalWarn.apply(console, args);
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Web vitals: only send to analytics when user has consented to analytics cookies.
reportWebVitals((metric) => {
  if (mayLoadAnalytics() && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', metric.name, {
        value: Math.round(metric.value),
        event_label: metric.id,
        non_interaction: true,
      });
    }
  }
});
